import { Box, Button, TextInput } from "@mantine/core";
import { IconSend2 } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

interface ChatImagePreviewInputProps {
  sendMessage: () => void;
  mutationIsLoading: boolean;
  isSending: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  textInputRef: React.RefObject<HTMLInputElement>;
  message: string;
  canSend: boolean;
  isDesktop: boolean;
}

export const ChatImagePreviewInput: React.FC<ChatImagePreviewInputProps> = ({
  sendMessage,
  mutationIsLoading,
  isSending,
  handleChange,
  handleKeyDown,
  textInputRef,
  message,
  canSend,
  isDesktop,
}) => {
  const { t } = useTranslation("discussions");

  return (
    <Box
      style={{
        flexShrink: 0,
        padding: isDesktop ? "16px 0 32px" : "16px 20px 32px",
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#000000",
      }}
    >
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          width: "100%",
          maxWidth: isDesktop ? 480 : undefined,
        }}
      >
        <TextInput
          ref={textInputRef}
          type="text"
          placeholder={t("message")}
          value={message}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          style={{ flex: 1 }}
          maxLength={4096}
          styles={{
            input: {
              border: 0,
              borderRadius: "5px",
              backgroundColor: "#1E1E1E",
              color: "var(--color-white)",
            },
          }}
        />
        <Button
          type="button"
          aria-label="Send message"
          onClick={sendMessage}
          disabled={mutationIsLoading || isSending || !canSend}
          className={`text-white w-10 h-10 flex items-center justify-center rounded-full ${
            canSend ? "bg-blue-dark" : "bg-gray-medium"
          }`}
        >
          <IconSend2 width={24} height={24} />
        </Button>
      </Box>
    </Box>
  );
};
